import ContactSection from "../components/ContactSection";
import ContactHero from "../components/Contact/ContactHero";
import ContactForm from "../components/Contact/ContactForm";
export default function Contact() {
  return (
    <div>
      <ContactHero />
      <ContactForm />
    
    </div>
  );
}
